import { getNodePayload } from 'pages/provisioning/couchbase/getNodePayload';

export const getPayload = ({ order = [], catalogCode, catalogServiceId }) => {
    const tags = {};

    // Formatting Tags for submitOrderAPI
    order?.tags?.forEach((tag) => {
        if (tag.name === 'Sector') {
            tags[tag.name] = order?.sector || '-';
        } else if (tag.name === 'BillingEntity') {
            tags[tag.name] = order?.billingEntity;
        } else if (tag.name === 'CostCenter') {
            tags[tag.name] = order?.hCodeDetails?.label;
        } else {
            tags[tag.name] = tag.defaultValue;
        }
    });
    tags['pep-business-category'] = order?.businessCategory;
    tags['pep-dataclassification'] = order?.appProfileDetails?.data?.dataClassification;

    const payload = {
        entityDetails: {
            name: order?.appProfile,
            businessCi: order?.entityDetails?.businessCi,
            applicationManager: order?.entityDetails?.owner?.name,
            applicationManagerEmail: order?.entityDetails?.owner?.emailId,
            applicationManagerGpid: order?.entityDetails?.owner?.id,
            costCenter: order?.entityDetails?.financialDetails,
            project: order?.hCodeDetails?.projectName || null,
            recoveryPriority: order?.entityDetails?.recoveryPriority,
            billingEntity: order?.entityDetails?.billingEntity || '-',
            sector: order?.entityDetails?.sector || null,
        },
        catalogService: {
            ...(catalogServiceId && { catalogServiceId }),
            cloudProvider: order?.cloudProvider,
            cloudService: order?.cloudService,
            catalogServiceCode: catalogCode,
            catalogType: order?.catalogType,
            sector: order?.sector,
            estimatedCost: { ...order?.estimatedCost, type: catalogCode },
            quantity: 1,
            catalogConfig: {
                billingEntity: order?.billingEntity,
                cluster: order?.cluster,
                dbVersion: order?.dbVersion,
                nodesCount: order?.nodesCount,
                components: getNodePayload({ order, tags }),
                serviceMappings: order?.serviceMappings?.map((item) => ({
                    clusterService: item?.clusterService,
                    memoryQuota: item?.memoryQuota,
                    storagePath: item?.storagePath,
                    nodes: item?.nodes,
                    isMemoryRequired: item?.isMemoryRequired,
                })),
                buckets: order?.buckets?.map((item) => ({
                    bucketType: item?.bucketType,
                    bucketNames: item?.bucketNames?.map((z1) => z1.name),
                    bucketMemSize: item?.bucketMemSize,
                })),
                environmentDetails: {
                    subscription: order?.envDetails?.config?.subscription?.name,
                    subscriptionId: order?.envDetails?.config?.subscription?.id,
                    resourceGroup: order?.envDetails?.config?.resourceGroup,
                    virtualNetwork: order?.envDetails?.config?.vnet?.name,
                    virtualNetworkId: order?.envDetails?.config?.vnet?.id,
                    subNetName: order?.envDetails?.config?.subnet,
                    networkSecurityGroup: order?.envDetails?.config?.networkSecurityGroup || null,
                    applicationSecurityGroup: order?.envDetails?.config?.applicationSecurityGroup || null,
                    applicationManager: order?.envDetails?.applicationManager,
                    applicationManagerEmail: order?.envDetails?.applicationManagerEmail,
                    applicationManagerGpid: order?.envDetails?.applicationManagerGpid,
                    businessService: order?.envDetails?.businessService,
                    drPriority: order?.envDetails?.drPriority,
                    metallic: order?.envDetails?.metallic,
                    backupTier: order?.envDetails?.backupTier,
                    environment: order?.environment,
                    projectName: order?.hCodeDetails?.projectName || null,
                    region: order?.region,
                    applicationTier: order?.appTier || '',
                    appTierCode: order?.appTierCode || '',
                    costCenter: order?.hCode,
                    asr: order?.envDetails?.asr === 'enabled',
                    landingZoneId: order?.landingZoneDetails?.id,
                },
                tags,
            },
        },
    };
    return payload;
};
export default getPayload;
